<template>
  <div>
    <ValidationObserver ref="validator" slim v-slot="{ handleSubmit, passed }">
      <h3 class="lib__text-center">{{ $t('meter.modifiedConnectionForm.title') }}</h3>

      <div class="row">

        <div class="col-xs-12 lib__field">
          <p class="lib__field__label">{{ $t('meter.form.type') }}</p>
          <div class="lib__field__group lib__no-margin">
            <div class="lib__field lib__field--radio lib__no-margin">
              <input @click="meterTypeChange(true)" class="lib__field__input" type="radio"
                name="meterTypeModifiedConnection" id="simple_modified_connection"
                :checked="connection.type === 'simple'">
              <label class="lib__field__label" for="simple_modified_connection">{{
                $t('meter.type.simple') }}</label>
            </div>
            <div class="lib__field lib__field--radio lib__no-margin">
              <input @click="meterTypeChange(false)" class="lib__field__input" type="radio"
                name="meterTypeModifiedConnection" id="dual_modified_connection" :checked="connection.type === 'dual'">
              <label class="lib__field__label" for="dual_modified_connection">{{
                $t('meter.type.dual') }}</label>
            </div>
          </div>
        </div>
      </div>

      <collapsable-text-area :max='500' :add-label="$t('meter.form.remarks')" :label="$t('meter.form.remarks')"
        v-model="connection.remarks" />
      <div class="lib__text-center">
        <a @click="handleSubmit(submit)" class="lib__btn lib__btn--primary lib__btn--rounded" href="#">
          <slot>
            <i class="fas fa-check"></i>
            <span>{{ $t('common.confirm') }}</span>
          </slot>
        </a>
      </div>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { ModifiedConnection } from '@/models/configuration-info'
import { helper } from '@ores/vue-library'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {},
  name: 'cmh-electricity-modified-connection-form'
})
export default class CmhElectricityModifiedConnectionForm extends Vue {
  //#region [Property]
  @Prop({ type: Object, required: true }) public modifiedConnection!: ModifiedConnection
  @Prop({ type: Object, required: true }) public defaultModifiedConnection!: ModifiedConnection
  //#endregion

  //#region [Data]

  public connection: ModifiedConnection = {
    count: null,
    type: null,
    price: null,
    remarks: null
  }

  //#endregion

  //#region [Method]
  public mounted() {    
    this.connection = this.modifiedConnection ? helper.clone(this.modifiedConnection) : helper.clone(this.defaultModifiedConnection)
  }

  meterTypeChange(isSimple: boolean) {
    this.connection.type = isSimple ? 'simple' : 'dual'
  }

  public submit() {
    this.$emit('submit', this.connection)
  }
  //#endregion
}
</script>